import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromReportReducer from '../reducers/report.reducer';
import * as fromApp from '../app.reducer';

const selectReporState = createSelector(
  fromApp.selectAppState,
  (state: fromApp.AppState) => state.report
);

export const selectReportEntities = createSelector(
  selectReporState,
  fromReportReducer.selectEntities
);

export const selectAllReports = createSelector(
  selectReporState,
  fromReportReducer.selectAll
);

export const selectLoading = createSelector(
  selectReporState,
  (state) => state.loading
);

export const selectError = createSelector(
  selectReporState,
  (state) => state.error
);

export const selectCrudCompleted = createSelector(
  selectReporState,
  (state) => state.crudCompleted
);

export const selectReportToEdit = createSelector(
  selectReporState,
  (state) => state.reportToEdit
);

export const selectDownloadedReport = createSelector(
  selectReporState,
  (state) => state.downloadedReport
);

export const selectOptimisticLockError = createSelector(
  selectReporState,
  (state) => state.optimisticLockError
);
